import { render } from "./bill.vue?vue&type=template&id=bb1e16dc&scoped=true"
import script from "./bill.vue?vue&type=script&lang=js"
export * from "./bill.vue?vue&type=script&lang=js"

import "./bill.vue?vue&type=style&index=0&id=bb1e16dc&lang=scss"
import "./bill.vue?vue&type=style&index=1&id=bb1e16dc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb1e16dc"],['__file',"src/views/account_center/components/bill.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb1e16dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb1e16dc', __exports__)) {
    api.reload('bb1e16dc', __exports__)
  }
  
  module.hot.accept("./bill.vue?vue&type=template&id=bb1e16dc&scoped=true", () => {
    api.rerender('bb1e16dc', render)
  })

}


export default __exports__